import { Button } from "@/components/ui/button";
import { Facebook, Linkedin, Link2, MessageCircle } from "lucide-react";
import { toast } from "sonner";

/**
 * Renders a row of one-click share buttons.
 * Opens the platform's native share composer pre-filled with title + URL.
 */
export default function ShareButtons({ url, title, summary, className = "" }) {
  const fullUrl = url.startsWith("http") ? url : `https://azuregypsy.org${url}`;
  const text = encodeURIComponent(`${title} — ${summary || ""}`.trim());
  const encUrl = encodeURIComponent(fullUrl);

  const targets = [
    {
      id: "facebook",
      label: "Facebook",
      icon: Facebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}`,
    },
    {
      id: "linkedin",
      label: "LinkedIn",
      icon: Linkedin,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encUrl}`,
    },
    {
      id: "x",
      label: "X",
      icon: MessageCircle,
      href: `https://twitter.com/intent/tweet?url=${encUrl}&text=${text}`,
    },
  ];

  const copy = () => {
    navigator.clipboard?.writeText(fullUrl);
    toast.success("Link copied. Paste anywhere.");
  };

  return (
    <div data-testid="share-buttons" className={`flex flex-wrap gap-2 ${className}`}>
      {targets.map((t) => (
        <a
          key={t.id}
          data-testid={`share-${t.id}`}
          href={t.href}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex"
        >
          <Button variant="outline" size="sm" className="border-stone-300 hover:border-emerald-800">
            <t.icon size={14} className="mr-2" />
            {t.label}
          </Button>
        </a>
      ))}
      <Button
        data-testid="share-copy"
        onClick={copy}
        variant="outline"
        size="sm"
        className="border-stone-300 hover:border-emerald-800"
      >
        <Link2 size={14} className="mr-2" />
        Copy Link
      </Button>
    </div>
  );
}
